import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AuthGuard } from '../../../../shared/auth/auth.guard';
import { AuthService } from '../../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { ComponentService } from '../../../../shared/abstract/component.service';
import { RequestService } from '../../../../shared/services/request.service';
import { FormType } from '../../../../shared/enum/form-type';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSelectChange } from '@angular/material/select';
import { MapComponentService } from '../../../../shared/map/map.component';
import { FormActionType } from '../../../../shared/enum/form-action-type';
import { UserFormTemplate } from '../../../../shared/entities/user-form-template';
import { NotificationAppType } from '../../../../shared/enum/authorize';
import { GeneralTypeEnum } from '../../../../shared/enum/general-type';
import { HighlightFormValueModel } from '../../../../shared/model/highlight-form-value-model';
import { NominatimSearchRequestModel } from '../../../../shared/model/nominatim-search-request-model';
import { NominatimReverseRequestModel } from '../../../../shared/model/nominatim-reverse-request-model';
import { AddressTypeEnum } from '../../../../shared/enum/address-type-enum';
import { ElementType } from '../../../../shared/enum/element-type';
import { TutorialTriggerService } from '../../../../shared/services/tutorial-trigger.service';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css'
})


export class SidemenuComponent extends ComponentService<any> implements OnInit, AfterViewInit {
  public mobileQuery: MediaQueryList;
  @Input() isSidenavOpened: boolean = false; // Handle sidenav state
  @ViewChild('sidenav', { static: true }) sidenav!: ElementRef;
  @Output() sideMenuState = new EventEmitter<boolean>();
  displayedProjects: any[] = [];
  private itemsPerPage = 10;
  private currentPage = 1;
  opened: boolean = false;
  leftSideMenuActive: boolean = false;
  sidenavWidth = 3;
  openedSidenavWidth = 20
  closedSidenavWith = 3
  ngStyle!: string;
  sideMenuList: any = [];
  public isShowSidebar: boolean;
  projects: any = [];
  selectedWorkForm: any;
  selectedTeamForm: any;
  selectedPoiForm: any;
  selectedProjectId: any;
  selectedProjectName: any;
  selectedRegionForm: any;
  selectedDefaultForm: any;
  selectedDepotForm: any;
  disableMouseLeave = false;
  showProjectsContainer: boolean = false;
  isInteractingWithChild = false;
  subscription!: Subscription;
  sideMenuOpenControl!: Subscription;
  formType = FormType;
  formActionType = FormActionType;
  disableClose: boolean = false;
  searchProjectName: string = '';
  truncateLimit = 0;

  private mobileQueryListener: () => void;

  constructor(
    injector: Injector,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private _authGuard: AuthGuard,
    private http: HttpClient,
    private _auth: AuthService,
    private breakpointObserver: BreakpointObserver,
    private _router: Router,
    private _request: RequestService,
    private _map: MapComponentService,
    private tutorialTrigger: TutorialTriggerService) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);

    this.isShowSidebar = !this.mobileQuery.matches;
  }

  ngOnInit(): void {
    this.sideMenuList = this.sideMenuAuthControl();
    this._router.navigate(["/application/" + this.sideMenuList[0].path]);
    this.projects = this._appsService.projects;
    this.selectedProjectId = this._appsService.selectedProject;

    this.loadMoreProjects();
    this.setLastSelectedTemplate();
    this.setTruncateLimit();

    //var model = new NominatimReverseRequestModel();
    //model.lon = 32.8541
    //model.lat = 39.9208
    //model.addressType = AddressTypeEnum.OSM;

    //this._request.reverse(model).then(res => {
    //  console.log(res);
    //})

    this.sideMenuOpenControl = this._appsService.sideMenuOpenControl.subscribe(res => {
      if (res != null || res != undefined) {
        if (res.formType == this.formType.Work && res.notificationTypeId == NotificationAppType.CalculateVrp) {
          this.dynamicOperations(res.formType);
        }
        if (res.notificationTypeId == NotificationAppType.CatchmentType) {
          this.dynamicOperations(this.formType.Work);
        }
        if (res.formType == this.formType.Team && res.notificationTypeId == NotificationAppType.CalculateTsp) {
          this.dynamicOperations(res.formType);
          this._appsService.rightSidebarControl.next({ state: 'open', type: res.formType, operation: 'update', transactionGuid: res.transactionGuid ,notificationTspControl:true});
        }

      }
    })


    this.subscription = this._appsService.projectData.subscribe(res => {
      if (res) {
        this.selectedProjectName = this._appsService.projects?.find(x => x.id == res).projectName;
        this.selectedProjectId = res;
      }
    })

    this._appsService.leftSideMenuActiveSubscription.subscribe(res => {

      if (res != undefined || res != null) {
        this.leftSideMenuActive = res;
      }
    })

    this._appsService.getFormsGlobal().then(res => {
      var userFormTemplate = new UserFormTemplate();
      userFormTemplate.userId = this._appsService.userInfos.id
      userFormTemplate.projectId = this._appsService.selectedProject;

      //TEAM
      if (this._appsService.lastFormTemplateIds.teamTemplateId == 0 || this._appsService.lastFormTemplateIds.teamTemplateId == undefined) {
        this._appsService.selectedTeamForm = this._appsService.teamForms[0];
        this.selectedTeamForm = this._appsService.selectedTeamForm;
        if (this._appsService.selectedTeamForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedTeamForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedTeamForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedTeamForm = this._appsService.teamForms.find(x => x.id == this._appsService.lastFormTemplateIds.teamTemplateId);
        this.selectedTeamForm = this._appsService.selectedTeamForm;

        if (this._appsService.selectedTeamForm == null || this._appsService.selectedTeamForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.teamForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.teamForms[0].templateTypeId;
          this._appsService.selectedTeamForm = this._appsService.teamForms[0];
          this.selectedTeamForm = this._appsService.selectedTeamForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }

      //POI
      if (this._appsService.lastFormTemplateIds.poiTemplateId == 0 || this._appsService.lastFormTemplateIds.poiTemplateId == undefined) {
        this._appsService.selectedPoiForm = this._appsService.poiForms[0];
        this.selectedPoiForm = this._appsService.selectedPoiForm;
        if (this._appsService.selectedPoiForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedPoiForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedPoiForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedPoiForm = this._appsService.poiForms.find(x => x.id == this._appsService.lastFormTemplateIds.poiTemplateId);
        this.selectedPoiForm = this._appsService.selectedPoiForm;

        if (this._appsService.selectedPoiForm == null || this._appsService.selectedPoiForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.poiForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.poiForms[0].templateTypeId;
          this._appsService.selectedPoiForm = this._appsService.poiForms[0];
          this.selectedPoiForm = this._appsService.selectedPoiForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }


      //DEPOT
      if (this._appsService.lastFormTemplateIds.depotTemplateId == 0 || this._appsService.lastFormTemplateIds.depotTemplateId == undefined) {
        this._appsService.selectedDepotForm = this._appsService.depotForms[0];
        this.selectedDepotForm = this._appsService.selectedDepotForm;
        if (this._appsService.selectedDepotForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedDepotForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedDepotForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }
      else {
        this._appsService.selectedDepotForm = this._appsService.depotForms.find(x => x.id == this._appsService.lastFormTemplateIds.depotTemplateId);
        this.selectedDepotForm = this._appsService.selectedDepotForm;

        if (this._appsService.selectedDepotForm == null || this._appsService.selectedDepotForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.depotForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.depotForms[0].templateTypeId;
          this._appsService.selectedDepotForm = this._appsService.depotForms[0];
          this.selectedDepotForm = this._appsService.selectedDepotForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }


      //REGION
      if (this._appsService.lastFormTemplateIds.regionTemplateId == 0 || this._appsService.lastFormTemplateIds.regionTemplateId == undefined) {
        this._appsService.selectedRegionForm = this._appsService.regionForms[0];
        this.selectedRegionForm = this._appsService.selectedRegionForm;
        if (this._appsService.selectedRegionForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedRegionForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedRegionForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedRegionForm = this._appsService.regionForms.find(x => x.id == this._appsService.lastFormTemplateIds.regionTemplateId)
        this.selectedRegionForm = this._appsService.selectedRegionForm;

        if (this._appsService.selectedRegionForm == null || this._appsService.selectedRegionForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.regionForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.regionForms[0].templateTypeId;
          this._appsService.selectedRegionForm = this._appsService.regionForms[0];
          this.selectedRegionForm = this._appsService.selectedRegionForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }


      //WORK
      if (this._appsService.lastFormTemplateIds.workTemplateId == 0 || this._appsService.lastFormTemplateIds.workTemplateId == undefined) {
        this._appsService.selectedWorkForm = this._appsService.workForms[0];
        this.selectedWorkForm = this._appsService.selectedWorkForm;
        if (this._appsService.selectedWorkForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedWorkForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedWorkForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedWorkForm = this._appsService.workForms.find(x => x.id == this._appsService.lastFormTemplateIds.workTemplateId);
        this.selectedWorkForm = this._appsService.selectedWorkForm

        if (this._appsService.selectedWorkForm == null || this._appsService.selectedWorkForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.workForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.workForms[0].templateTypeId;
          this._appsService.selectedWorkForm = this._appsService.workForms[0];
          this.selectedWorkForm = this._appsService.selectedWorkForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }

      //DEFAULT
      if (this._appsService.lastFormTemplateIds.defaultTemplateId == 0 || this._appsService.lastFormTemplateIds.defaultTemplateId == undefined) {
        this._appsService.selectedDefaultForm = this._appsService.defaultForms[0];
        this.selectedDefaultForm = this._appsService.selectedDefaultForm;
        if (this._appsService.selectedDefaultForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedDefaultForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedDefaultForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }
      else {
        //if previous selectedFormDeletedOrUpdated set the first one
        this._appsService.selectedDefaultForm = this._appsService.defaultForms.find(x => x.id == this._appsService.lastFormTemplateIds.defaultTemplateId);
        this.selectedDefaultForm = this._appsService.selectedDefaultForm;

        if (this._appsService.selectedDefaultForm == null || this._appsService.selectedDefaultForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this._appsService.defaultForms[0].id;
          userFormTemplate.formTemplateTypeId = this._appsService.defaultForms[0].templateTypeId;
          this._appsService.selectedDefaultForm = this._appsService.defaultForms[0];
          this.selectedDefaultForm = this._appsService.selectedDefaultForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }

    }).catch((error) => {
      console.error("An error occurred:", error);
    })
      .finally(() => {
        this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);

      });
  }

  ngAfterViewInit() {
    this.projects = this._appsService.projects;
    this.selectedProjectName = this._appsService.projects?.find(x => x.id == this.selectedProjectId)?.projectName;



  }

  toggleSidenav() {
    if (this.sidenavWidth == this.openedSidenavWidth) {
      this.sidenavWidth = this.closedSidenavWith
      this.expandedItems = {};
    }
    else {
      this.sidenavWidth = this.openedSidenavWidth;
    }

    //this.sidenavWidth = this.sidenavWidth == 25 ? 4 : 25;
  }
  expandedItems: { [key: number]: boolean } = {}; // Store expanded state for each item


  displayProjects() {
    this.showProjectsContainer = !this.showProjectsContainer

    if (this.leftSideMenuActive) {
      this.sidenavWidth = this.openedSidenavWidth;
    }

  }

  toggleExpansion(index: number): void {
    this._appsService.logInfo(this.languageKey(this.sideMenuList[index].menuName) + " " + "görüntülendi");
    this.sideMenuList[index].dropState = !this.sideMenuList[index].dropState
    if (this.sideMenuList[index].menuName == 'planner') {
      this.leftSideMenuActive = false;
    }
    if (this.leftSideMenuActive) {
      this.sidenavWidth = this.openedSidenavWidth;

    }
    else {
      if (this.sideMenuList[index].menuName == 'planner') {
        this.sidenavWidth = this.closedSidenavWith;
        this.leftSideMenuActive = true;
        this._appsService.isSidenavOpenedSubscription.next(false);
        this.sideMenuList = this.sideMenuAuthControl();
        this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);
        this._appsService.plannerSidebar.next(true);
      }
    }
    // this._appsService.isSidenavOpenedSubscription.next(false);
  }

  onSideMenuItemClick(index: number): void {
    const sideMenuItem = this.sideMenuList?.[index];
    if (sideMenuItem) {
      const tag = sideMenuItem.tutorialId || ('tutorial-sidemenu-' + sideMenuItem.menuName);
      this.tutorialTrigger.emitTag(tag, { menuName: sideMenuItem.menuName, path: sideMenuItem.path }, 'sidemenu');
    }

    this.toggleExpansion(index);
  }

  onSubMenuItemClick(subMenuItem: any): void {
    if (subMenuItem?.tutorialId) {
      this.tutorialTrigger.emitTag(subMenuItem.tutorialId, { menuName: subMenuItem.menuName, type: subMenuItem.type, operation: subMenuItem.operation }, 'sidemenu');
    }

    this.dynamicOperations(subMenuItem.type);
  }

  onSubMenuMapOperationClick(subMenuItem: any): void {
    if (subMenuItem?.tutorialId) {
      this.tutorialTrigger.emitTag(subMenuItem.tutorialId, { menuName: subMenuItem.menuName, type: subMenuItem.type, operation: subMenuItem.operation }, 'sidemenu');
    }

    this.dynamicMapOperations(subMenuItem.type, subMenuItem.operation);
  }


  interact() {
    this.isInteractingWithChild = true;

  }

  leave(event: MouseEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;

    // Check if the related target is inside the sidenav or the dropdown
    if (relatedTarget && (relatedTarget.closest('.cdk-overlay-container'))) {
      return;
    }

    this.isInteractingWithChild = false;
  }

  increase() {
    //if (!this.disableMouseLeave && !this.isInteractingWithChild) {
    //  this.sidenavWidth = this.openedSidenavWidth;
    //}
    if (!this.leftSideMenuActive) {
      this.sidenavWidth = this.openedSidenavWidth;
      //this.sideMenuState.emit(false);
    }

  }

  decrease() {
    if (!this.isSidenavOpened && !this.isInteractingWithChild) {
      this.sidenavWidth = this.closedSidenavWith;
      this.showProjectsContainer = false;
      this.sideMenuList = this.sideMenuAuthControl();
      this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);
      //this.sideMenuState.emit(true);
    }
  }


  directDecrease() {
    this.sidenavWidth = this.closedSidenavWith;
    this.showProjectsContainer = false;
    this.sideMenuList = this.sideMenuAuthControl();
    this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);
    //this.sideMenuState.emit(true);

  }

  directIncrease() {
    this.sidenavWidth = this.openedSidenavWidth;
    this.showProjectsContainer = false;
    this.sideMenuList = this.sideMenuAuthControl();
    this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);
    //this.sideMenuState.emit(false);

  }


  //decrease() {
  //  this.sidenavWidth = this.closedSidenavWith;
  //  this.sideMenuList = JSON.parse(JSON.stringify(sideMenuRoute));


  //}

  openSidenav(): void {
    this.opened = true;
  }

  // Method to close the sidenav
  closeSidenav(): void {
    this.opened = false;
  }

  onDropdownToggle() {



  }



  onSelectedProject(projectId: number) {
    //this._appsService.projects = this.projects;
    //this.onSelectedProject(this.projects[0].id);
    this.selectedProjectId = projectId;
    this._appsService.selectedProject = projectId;
    //this._appsService.projectData.next(projectId);
    this.selectedProjectName = this._appsService.projects?.find(x => x.id == this._appsService.selectedProject).projectName;

    this._request.setCurrentProject(projectId).then(_ => {
      const p = this.projects.find(p => p.id == projectId);
      p != null ? this._appsService.getCurrentProject(p) : false;
      this._appsService.getSettings();
    })
    const message = this.languageKey("selectedProjectMessage")
      .replace("{{projectName}}", this.selectedProjectName);

    localStorage.setItem("reloadMessage", message);
    this._appsService.logInfo(projectId + " id li proje görüntülendi");
    window.location.reload();
  }


  onItemSelected(type, event: MatSelectChange) {
    var message = "";
    var formTypeMessage = "";
    var userFormTemplate = new UserFormTemplate();
    switch (type) {
      case FormType.Work:
        this._appsService.selectedWorkForm = this.selectedWorkForm;
        userFormTemplate.formTemplateId = this.selectedWorkForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan İş Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li iş formu varsayılan olarak ayarlandı");
        break;
      case FormType.Team:
        this._appsService.selectedTeamForm = this.selectedTeamForm;
        userFormTemplate.formTemplateId = this.selectedTeamForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan Takım Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li ekip formu varsayılan olarak ayarlandı");
        break;
      case FormType.Poi:
        this._appsService.selectedPoiForm = this.selectedPoiForm;
        userFormTemplate.formTemplateId = this.selectedPoiForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan Poi Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li poi formu varsayılan olarak ayarlandı");
        break;
      case FormType.Depot:
        this._appsService.selectedDepotForm = this.selectedDepotForm;
        userFormTemplate.formTemplateId = this.selectedDepotForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan Depo Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li depo formu varsayılan olarak ayarlandı");
        break;
      case FormType.Region:
        this._appsService.selectedRegionForm = this.selectedRegionForm;
        userFormTemplate.formTemplateId = this.selectedRegionForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan Bölge Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li bölge formu varsayılan olarak ayarlandı");
        break;
      case FormType.Default:
        this._appsService.selectedDefaultForm = this.selectedDefaultForm;
        userFormTemplate.formTemplateId = this.selectedDefaultForm.id;
        userFormTemplate.formTemplateTypeId = type;
        formTypeMessage = "Varsayılan Anket Formu"
        this._appsService.logInfo(userFormTemplate.formTemplateId + " id li anket formu varsayılan olarak ayarlandı");
        break;

    }
    userFormTemplate.userId = this._appsService.userInfos.id
    userFormTemplate.projectId = this._appsService.selectedProject;



    this._request.addOrUpdateUserFormTemplate(userFormTemplate).then(res => {
      if (res?.code == 1) {
        message = formTypeMessage + ' ' + event?.value?.templateName + ' olarak ayarlandı';
        this.MessageBox(message, 'primary', 'center');
      }
    })



  }




  dynamicOperations(type) {
    var formTemplateId: any;
    var templateVersion: any;
    var templateName: any;

    if ([4, 5, 6].includes(type)) {
      this._appsService.setSelectedTab(type);
      this._appsService.setComingFormType(type);
    }

    switch (type) {
      case FormType.Work:
        formTemplateId = this.selectedWorkForm?.id;
        templateVersion = this.selectedWorkForm?.templateVersion;
        templateName = this.selectedWorkForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait işler listelendi");
        break;
      case FormType.Team:
        formTemplateId = this.selectedTeamForm?.id;
        templateVersion = this.selectedTeamForm?.templateVersion;
        templateName = this.selectedTeamForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait ekipler listelendi");
        break;
      case FormType.Poi:
        formTemplateId = this.selectedPoiForm?.id;
        templateVersion = this.selectedPoiForm?.templateVersion;
        templateName = this.selectedPoiForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait poiler listelendi");
        break;
      case FormType.PoiCategory:
        formTemplateId = 0;
        templateVersion = 0;
        templateName = "Poi Kategori";
        this._appsService.addressSearchControl = false;
        this._appsService.logInfo(formTemplateId + " li forma ait poi kategoriler listelendi");
        break;
      case FormType.Depot:
        formTemplateId = this.selectedDepotForm?.id;
        templateVersion = this.selectedDepotForm?.templateVersion;
        templateName = this.selectedDepotForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait depolar listelendi");
        break;
      case FormType.Region:
        formTemplateId = this.selectedRegionForm?.id;
        templateVersion = this.selectedRegionForm?.templateVersion;
        templateName = this.selectedRegionForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait bölgeler listelendi");
        break;
      case FormType.Default:
        formTemplateId = this.selectedDefaultForm?.id;
        templateVersion = this.selectedDefaultForm?.templateVersion;
        templateName = this.selectedDefaultForm?.templateName;
        this._appsService.addressSearchControl = true;
        this._appsService.logInfo(formTemplateId + " li forma ait anketler listelendi");
        break;
    }

    this._appsService.leftSidebarControl.next({ state: 'open', type: type, formTemplateId: formTemplateId, templateVersion: templateVersion, templateName: templateName });
    //this.disableMouseLeave = true;
    this.sidenavWidth = this.closedSidenavWith;
    this.leftSideMenuActive = true;
    //this.sideMenuState.emit(false);
    this._appsService.isSidenavOpenedSubscription.next(false);
    //this._appsService.sidenavToggleState.next(false);
    this.sideMenuList = this.sideMenuAuthControl();
    this.sideMenuList = this.sideMenuFormControl(this.sideMenuList);

    this._request.getVDynamicElementFilter(formTemplateId, templateVersion, this._appsService.existCurrentProject?.companyId, type != FormType.Team ? this._appsService.existCurrentProject?.projectId : null).then((res) => {
      if (res.length > 0) {
        this._appsService.filterElements = res.filter(x => x.typeId != ElementType.CountryBox && x.typeId != ElementType.CityBox && x.typeId != ElementType.CountyBox && x.typeId != ElementType.NeighbourhoodBox);
        if (type == FormType.Work) {
          let teamModel = {
            label: 'Ekip Adı',
            typeId: 4,
            keyValueDesModels: [],
            value: ''
          }
          this._appsService.filterElements.unshift(teamModel);

          let pointModel = {
            label: 'Nokta Adı',
            typeId: 4,
            keyValueDesModels: [],
            value: ''
          }
          this._appsService.filterElements.unshift(pointModel);
        }
      }
      else {
        this._appsService.filterElements = [];
      }
    });


  }

  dynamicMapOperations(type, operation) {
    if (type == 5 && operation == 2) {
      this._appsService.sideMenuDrawControl.next({ type: 'marker', formType: FormType.Poi });
      this._appsService.logInfo("Poi noktası ekleme butonuna tıklandı");
    }
    else if (type == 9 && operation == 2) {
      this._appsService.sideMenuDrawControl.next({ type: 'polygon', formType: FormType.Region });
      this._appsService.logInfo("Bölge ekleme butonuna tıklandı");
    }
    else {
      this._appsService.rightSidebarControl.next({ state: 'open', type: type, operation: 'create' });
      this._appsService.logInfo("Sidebardan dinamik veri ekleme butonuna tıklandı");
    }
  }

  onScroll(event: any): void {
    const container = event.target;

    // Check if user has scrolled to the bottom
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
      this.loadMoreProjects(); // Adjust to prevent off-by-one issues
    }
  }

  loadMoreProjects(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = this.currentPage * this.itemsPerPage;

    const nextItems = this.projects.slice(startIndex, endIndex);
    this.displayedProjects = [...this.displayedProjects, ...nextItems];

    this.currentPage++;
  }


  setLastSelectedTemplate(): void {

    this._request.getUserFormTemplates(this._appsService.userInfos.id, this._appsService.selectedProject).then(res => {

      if (res?.data && res.data.length > 0) {
        this._appsService.lastFormTemplateIds.workTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Work)?.formTemplateId;
        this._appsService.lastFormTemplateIds.teamTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Team)?.formTemplateId;
        this._appsService.lastFormTemplateIds.defaultTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Default)?.formTemplateId;
        this._appsService.lastFormTemplateIds.depotTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Depot)?.formTemplateId;
        this._appsService.lastFormTemplateIds.regionTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Region)?.formTemplateId;
        this._appsService.lastFormTemplateIds.poiTemplateId = res.data.find(x => x.formTemplateTypeId == FormType.Poi)?.formTemplateId;
      }

    })

  }

  filterProject() {
    return this._appsService?.projects?.filter(item =>
      item?.projectName.toLowerCase().includes(this.searchProjectName?.toLowerCase())
    );
  }

  setTruncateLimit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]).subscribe(result => {
      if (this._appsService.classes === 'global-large') {
        if (result.matches && result.breakpoints[Breakpoints.XSmall]) {
          this.truncateLimit = 15;
        } else if (result.matches && result.breakpoints[Breakpoints.Small]) {
          this.truncateLimit = 30;
        }
        else if (result.matches && result.breakpoints[Breakpoints.XLarge]) {
          this.truncateLimit = 30;
        }
        else {
          this.truncateLimit = 20;
        }
      } else if (this._appsService.classes === 'global-medium') {
        this.truncateLimit = 40;
      } else {
        this.truncateLimit = 30;
      }
    });
  }

  addOrUpdateUserFormTemplate(userFormTemplate: any) {
    this._request.addOrUpdateUserFormTemplate(userFormTemplate).then(res => {
      if (res?.code == 1) {
      }
    })
  }

}

